<template>
	<div class="app-secondary-text-field">
		<v-text-field v-bind="$attrs" v-on="$listeners" dense single-line hide-details outlined> </v-text-field>
	</div>
</template>

<script>
export default {
	name: 'AppSecondaryTextField',
	props: {},
};
</script>

<style scoped lang="scss">
.app-secondary-text-field {
}
</style>
